module.exports = __webpack_public_path__ + "img/banner-4.dc105be3.jpg";